import { render } from "./bottomNavBar.vue?vue&type=template&id=278eeb90&scoped=true"
import script from "./bottomNavBar.vue?vue&type=script&lang=js"
export * from "./bottomNavBar.vue?vue&type=script&lang=js"

import "./bottomNavBar.vue?vue&type=style&index=0&id=278eeb90&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278eeb90"]])

export default __exports__